export default function readingTime(value) {
  const wordsCount = value.split(' ').length;
  const wordsPerMinute = 200;

  return wordsCount / wordsPerMinute;
}
